export default __webpack_public_path__ + "static/InfoLinks_Default-dbbfe874a6f68d23d44295da559f8ff1.png";